import moment from 'moment';
import qs from 'qs';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { createSelector } from '@reduxjs/toolkit';
import { useGetSearchQuery } from 'store/queries/search';

export function useSearch() {
    const { search } = useLocation();
    const query = qs.parse(search, { ignoreQueryPrefix: true });

    const selectSearch = useMemo(
        () =>
            createSelector(
                (res) => res,
                (data) => ({
                    country: data?.country,
                    destination: data?.destination,
                    resort: data?.resort,
                    property: data?.property,
                    arrival: moment(data?.arrival),
                    departure: moment(data?.departure),
                    id: data?.id,
                    occupancy: data?.occupancy,
                }),
            ),
        [],
    );

    return useGetSearchQuery(query.sid, {
        selectFromResult: (result) => ({
            ...result,
            search: selectSearch(result.data),
        }),
        skip: !query.sid,
    });
}
